module.exports = __webpack_public_path__ + "static/img/barra_6.ce4c7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/barra_6.png
// module id = zgkP
// module chunks = 0